import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ReasonStatus" }
const _hoisted_2 = { class: "explain" }
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "open-status" }
const _hoisted_6 = { class: "tips" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.imgUrl,
          alt: ""
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.openStatusText), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.tips), 1)
    ]),
    _createElementVNode("div", {
      class: "btn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handle && _ctx.handle(...args)))
    }, _toDisplayString(_ctx.btnText), 1)
  ]))
}